"use client";
import React from "react";
import Link from "next/link";

const MarkdownLink = ({ href, children, ...props }: any) => { 
  if (!href) return <span>{children}</span>;
 
  // --- enlaces normales ---
  if (href.startsWith("/")) {
    return (
      <Link
        href={href}
        className="text-blue-400 underline hover:text-blue-300"
        {...props}
      >
        {children}
      </Link>
    );
  }
  if (href.startsWith("#")) {
    return (
      <a
        href={href}
        className="text-green-400 underline hover:text-green-300"
        {...props}
      >
        {children}
      </a>
    );
  }
  if (href.startsWith("mailto:")) {
    return (
      <a
        href={href}
        className="text-pink-400 underline hover:text-pink-300"
        {...props}
      >
        {children}
      </a>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-yellow-400 underline hover:text-yellow-300"
      {...props}
    >
      {children}
    </a>
  );
};

export default MarkdownLink;
